import BubbleModal from "../Shared/BubbleModal.tsx";
import {useTranslation} from "react-i18next";

interface DiscardSessionConfirmationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleDiscard: () => void;
}

export default function DiscardRecordingConfirmationModal({ open, setOpen, handleDiscard }: DiscardSessionConfirmationModalProps) {
  
  const { t } = useTranslation();
  
  return (
    <BubbleModal open={open} setOpen={setOpen}>
      <>
        <div className="sm:flex sm:items-start">
          <div
            className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
            <svg className="size-6 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                 stroke="currentColor"
                 aria-hidden="true" data-slot="icon">
              <path strokeLinecap="round" strokeLinejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
            </svg>
          </div>
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <h3 className="text-base font-semibold text-gray-900" id="modal-title">{t('sessions.discardRecordingTitle')}</h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">{t('sessions.discardRecordingDescription')}</p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6 sm:flex sm:flex-row-reverse">
          <button type="button"
                  className="cursor-pointer inline-flex w-full justify-center rounded-xl bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  onClick={() => {
                    handleDiscard();
                    setOpen(false);
                  }}
          >
            {t('sessions.discardRecording')}
          </button>
          <button type="button"
                  className="cursor-pointer mt-3 inline-flex w-full justify-center rounded-xl bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => {
                    setOpen(false)
                  }}
          >
            {t('sessions.continueRecording')}
          </button>
        </div>
      </>
    </BubbleModal>
  )
}